import { render, staticRenderFns } from "./AnnouncementList.vue?vue&type=template&id=52b8fcaa&scoped=true&"
import script from "./AnnouncementList.vue?vue&type=script&lang=js&"
export * from "./AnnouncementList.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementList.vue?vue&type=style&index=0&id=52b8fcaa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b8fcaa",
  null
  
)

/* custom blocks */
import block0 from "./AnnouncementList.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b8fcaa')) {
      api.createRecord('52b8fcaa', component.options)
    } else {
      api.reload('52b8fcaa', component.options)
    }
    module.hot.accept("./AnnouncementList.vue?vue&type=template&id=52b8fcaa&scoped=true&", function () {
      api.rerender('52b8fcaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InformationTab/AnnouncementList.vue"
export default component.exports